import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=4fc53cd8&"
import script from "./DynamicForm.ts?vue&type=script&lang=ts&"
export * from "./DynamicForm.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports